import { appConfig } from '@/config/app.ts'

export interface DrawState {
  isLoading: boolean
  isCreateModalOpen: boolean
  editId: number | null
  filters: string
}

export const initialState: DrawState = {
  isLoading: false,
  isCreateModalOpen: false,
  editId: null,
  filters: `?limit=${appConfig.pagination.defaultValue}`
}
